<template>
  <section v-if="getAccType != 'candidate'">
    <nav class="sidebar-nav" :class="{ toggle: toggler }">
      <div class="last-build">
        <p>
          Current version: <span>{{ version }}</span
          ><br />
          {{
            getComputedDate.build
              | formatDateComputed({
                format: getUserProfile.format_date,
                timezone: getUserProfile.timezone,
                hasHourAndMinutes: true,
              })
          }}
        </p>
      </div>
      <div class="sidebar-logo">
        <svgHelper name="logo"></svgHelper>
      </div>
      <ul class="list-group list-unstyled">
        <li v-if="getAccType !== 'marketing'" id="v-step-0">
          <router-link
            :to="{ name: `${getAccType}-dashboard` }"
            class="list-group-item list-group-item-action"
          >
            <i class="far fa-chart-bar mr-4"></i>Dashboard
          </router-link>
        </li>
        <li v-if="getAccType !== 'marketing'">
          <router-link
            :to="{ name: `${getAccType}-pipelines` }"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-filter mr-4"></i>Pipelines
          </router-link>
        </li>

        <li v-if="getAccType !== 'marketing'">
          <router-link
            :to="{ name: `${getAccType}-candidates` }"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-user-alt mr-4"></i>Candidates
          </router-link>
        </li>
        <li v-if="getAccType !== 'marketing'">
          <router-link
            :to="{ name: getAccType == 'recruiter' ? 'recruiter-jobs' : 'admin-jobs' }"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-briefcase mr-4"></i>Jobs
          </router-link>
        </li>

        <li v-if="getAccType === 'admin' || getAccType === 'recruiter'">
          <router-link
            :to="{ name: `${getAccType}-employers` }"
            class="list-group-item list-group-item-action"
          >
            <i class="fas fa-city mr-4"></i>Employers
          </router-link>
        </li>

        <li
          v-if="getAccType === 'admin' || getAccType === 'recruiter'"
          @mouseover="isHovering = true"
          @mouseout="isHovering = false"
          class="dropdown"
        >
          <router-link
            id="navigationLinks"
            :class="{ 'router-link-active': subIsActive(`/${getAccType}/review/jobs`) }"
            class="list-group-item list-group-item-action dropdown-toggle"
            :to="{ name: `${getAccType}-review-applications` }"
            data-toggle="dropdown"
          >
            <i class="fas fa-list-ul mr-4"></i>Review
          </router-link>

          <div
            class="dropdown-menu"
            :class="{ show: isHovering }"
            aria-labelledby="navigationLinks"
          >
            <router-link :to="{ name: `${getAccType}-review-applications` }" class="dropdown-item"
              >Applications</router-link
            >
            <router-link
              v-if="getAccType === 'admin'"
              :to="{ name: `${getAccType}-review-freelancers` }"
              class="dropdown-item"
              >Freelancing</router-link
            >
            <router-link
              v-if="getAccType === 'admin'"
              :to="{ name: `${getAccType}-review-jobs` }"
              class="dropdown-item"
              >Jobs</router-link
            >
            <router-link
              v-if="getAccType === 'admin'"
              :to="{ name: `${getAccType}-review-tests` }"
              class="dropdown-item"
              >Tests</router-link
            >
          </div>
        </li>

        <li
          v-if="getAccType === 'admin' || getAccType === 'marketing'"
          @mouseover="isHoveringTwo = true"
          @mouseout="isHoveringTwo = false"
          class="dropdown"
        >
          <router-link
            id="navigationLinks"
            class="list-group-item list-group-item-action dropdown-toggle"
            :to="{ name: `admin-marketing-jobs` }"
            data-toggle="dropdown"
          >
            <i class="fas fa-bullhorn fa-flip-horizontal mr-4"></i>Marketing
          </router-link>

          <div
            class="dropdown-menu"
            :class="{ show: isHoveringTwo }"
            aria-labelledby="navigationLinks"
          >
            <router-link
              v-if="getAccType === 'admin' || getAccType === 'marketing'"
              :to="{ name: `admin-marketing-jobs` }"
              class="dropdown-item"
              >Jobs</router-link
            >
            <router-link
              v-if="getAccType === 'admin' || getAccType === 'marketing'"
              :to="{ name: `admin-marketing-employers` }"
              class="dropdown-item"
              >Employers</router-link
            >
            <router-link
              v-if="getAccType === 'admin' || getAccType === 'marketing'"
              :to="{ name: `admin-marketing-contacts` }"
              class="dropdown-item"
              >Contacts</router-link
            >
          </div>
        </li>

        <li class="mt-3 signout" @click="logout">
          <span class="list-group-item list-group-item-action">
            <i class="fas fa-sign-out-alt mr-4"></i>Sign Out
          </span>
        </li>

        <li v-if="recent.length > 0 && getAccType !== 'marketing'" class="mt-1">
          <router-link
            v-if="recent[0].hasOwnProperty('job_id')"
            :to="{
              name: 'job_uuid',
              params: { job_uuid: recent[0].job_id, job_name: recent[0].job_name },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>

          <router-link
            v-if="recent[0].hasOwnProperty('candidate_id') && getAccType !== 'marketing'"
            :to="{
              name: 'candidate_id',
              params: {
                candidate_id: recent[0].candidate_id,
              },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>

          <router-link
            v-if="recent[0].hasOwnProperty('employer_id')"
            :to="{
              name: 'employer_id',
              params: {
                employer_id: recent[0].employer_id,
                employer_name: recent[0].employer_name,
              },
            }"
          >
            <span class="list-group-item list-group-item-action">
              <i class="fas fa-stopwatch mr-4"></i>Recent
            </span>
          </router-link>
        </li>

        <li class="mt-1" v-if="recent.length === 0 && getAccType !== 'marketing'">
          <span class="list-group-item list-group-item-action">
            <i class="fas fa-stopwatch mr-4"></i>Recent
          </span>
        </li>
        <ul class="list-group recent-group">
          <li v-for="recent in recent" :key="recent.id" class="recent-item">
            <router-link
              v-if="recent.hasOwnProperty('job_id')"
              :to="{
                name: 'job_uuid',
                params: { job_uuid: recent.job_id, job_name: recent.job_name },
              }"
            >
              {{ recent.job_name }}</router-link
            >
            <router-link
              v-if="recent.hasOwnProperty('candidate_id')"
              :to="{
                name: 'candidate_id',
                params: {
                  candidate_id: recent.candidate_id,
                },
              }"
            >
              {{ recent.candidate }}</router-link
            >
            <router-link
              v-if="recent.hasOwnProperty('employer_id')"
              :to="{
                name: 'employer_id',
                params: {
                  employer_id: recent.employer_id,
                  employer_name: recent.employer_name,
                },
              }"
            >
              {{ recent.employer_name }}</router-link
            >
          </li>
        </ul>
      </ul>
    </nav>
  </section>
</template>

<script>
import moment from 'moment';
import { canSeeMixin } from '../../mixins/canSeeMixin';
import { mapGetters } from 'vuex';
import axios from 'axios';
import version from '../../version';

export default {
  props: ['toggler'],
  mixins: [canSeeMixin],
  data: () => ({
    version: version,
    isHovering: false,
    isHoveringTwo: false,
    bugs: 33,
    recent: [],
  }),
  methods: {
    logout() {
      this.$store
        .dispatch('destroyToken')
        .then(() => {
          this.$router.push('/');
          sessionStorage.removeItem('first');
          this.$toasted.show('You are successfully logged out', {
            theme: 'bubble',
            icon: 'fa-check-circle',
            position: 'bottom-right',
            duration: 5000,
          });
        })
        .catch(() => {
          this.$router.push('/');

          this.$toasted.error('You are successfully logged out.', {
            theme: 'bubble',
            icon: 'fa-exclamation-circle',
            position: 'bottom-right',
            duration: 10000,
          });
        });
    },
    subIsActive(input) {
      const paths = Array.isArray(input) ? input : [input];

      return paths.some(path => {
        return this.$route.path.indexOf(path) === 0; // current path starts with this path string
      });
    },
    getRecentSeenList() {
      axios(`${process.env.VUE_APP_API_URL}/admin/recentseen/list`, {
        method: 'get',
        headers: {
          Authorization: `Bearer ${localStorage.getItem(
            `${process.env.VUE_APP_TOKEN_PREFIX}token`,
          )}`,
          'Content-Type': 'application/json',
          Accept: 'application/json',
        },
      })
        .then(res => {
          this.recent = res.data;
        })
        .catch(err => {});
    },
  },
  computed: {
    ...mapGetters(['getAccType', 'getUserProfile']),
    getComputedDate() {
      const buildDateElementFromIndex = document.documentElement.getAttribute(
        'data-build-timestamp-utc',
      );

      return {
        build: moment(buildDateElementFromIndex),
      };
    },
  },
  mounted() {
    this.getRecentSeenList();
  },
};
</script>

<style lang="scss" scoped>
@import '@/assets/scss/_variables.scss';
a {
  text-decoration: none !important;
}

.signout {
  cursor: pointer;
  display: none;
}
.recent-group {
  margin: 12px 0;

  .recent-item {
    margin: 0 !important;
    max-width: 175px;

    a {
      padding: 6px 20px;
      color: #fff;
      text-decoration: none;
      font-size: 13px;
      display: block;
      background: none !important;
    }

    &:hover {
      cursor: pointer;
      background: rgba(255, 255, 255, 0.1);
    }
  }
}

.fa-city {
  font-size: 11px;
}

.sidebar-logo {
  text-align: center;
  padding: 2rem;

  .svg-icon {
    width: 80px;
    height: 75px;
    margin-left: 10px;
  }
}

.dropdown {
  a::after {
    transform: rotate(-90deg);
  }
}

.dropdown-menu {
  background-color: rgb(14, 14, 14);
  margin-left: 100%;
  margin-top: -45px !important;
  border: 0 !important;
  border-radius: 0;

  a {
    color: $color-white;
    font-size: 14px;
  }

  a:hover {
    background-color: #f05a00;
  }
}

.last-build {
  position: absolute;
  bottom: 20px;
  left: 0;
  right: 0;
  margin: 0 auto;
  font-size: 0.7rem;
  color: rgb(180, 180, 180);
  text-align: center;

  p {
    margin: 0 0 0 -5px;
  }
}

@media only screen and (max-width: 1250px) {
  .signout {
    cursor: pointer;
    display: block;
  }
}
</style>
